<template>
    <div class="excavate-cluster">
        <div class="cluster-top">
            <div class="top-info">
                <p>
                    <b>距离类型：用以描述类与类之间相似度。</b>
                </p>
                <p>
                    <b>欧式距离：</b>多维空间的点点之间的几何距离。
                </p>
                <p>
                    <b>切比雪夫距离：</b>在多维空间中，对象从某个位置转移到另外一个对象所消耗的最少距离。
                </p>
                <p>
                    <b>绝对值距离：</b>计算从一个对象到另一个对象所经过的折线距离，有时也可以进一步的描述为多维空间中对象在各维的平均差。
                </p>
                <p>
                    <b>lance距离：</b>假定变量之间相互独立，在正交空间中的距离。
                </p>
            </div>
            <div class="top-info">
                <p>
                    <b>聚类方法：用以描述类与类之间的计算方法。</b>
                </p>
                <p>
                    <b>最长距离法：</b>类与类之间的距离为他们之间两个最远样品之间的距离。
                </p>
                <p>
                    <b>最短距离法：</b>一类所有的样本与另一类所有样品之间的之间的最短距离。
                </p>
                <p>
                    <b>类平均法：</b>两类样本中,所有观测值两两观测间距离的平均作为类间距离。
                </p>
                <p>
                    <b>重心法：</b>定义类间距离为两类重心（各类样本的均值）的距离。
                </p>
            </div>
        </div>
        <div class="cluster-search">
            <div class="cluster-info flex">
                <div >
                    类型：
                    <el-radio-group v-removeAriaHidden v-model="searchType" >
                        <el-radio @change="changeRadin" v-for="(item,index) in searchRadio" :key="index" :label="item.label">{{item.value}}</el-radio>
                    </el-radio-group>
                </div>
                <div>
                    筛选前<el-input class="search-num" :min="1" type='number' size='mini' v-model='searchNum'></el-input>个进行聚类
                </div>
                <div>
                    聚类方法：
                    <el-select  class="search-select" size='mini' v-model="clusterValue"  placeholder="请选择聚类方法">
                        <el-option
                        v-for="item in clusterOptins"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                <div>
                    距离类型：
                    <el-select class="search-select" size='mini' v-model="distanceValue"  placeholder="请选择距离类型">
                        <el-option
                        v-for="item in distanceOptins"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                <div>
                    <el-button  type="primary" size="small" @click="analysis">聚类分析</el-button>
                </div>
            </div>
        </div>
        <div class="excavate-table">
            <!-- 和K-means一样 -->
            <clusterTable ref="cluster_table"></clusterTable>
        </div>
    </div>
</template>
<script>

import { mapState,mapMutations, mapActions } from 'vuex';
import excavateData from './comps/excavateData.js'
import {getPinCi} from "../../io/api.js"
import clusterTable from './K_Means/cluster_table.vue';
export default {
    components: {
        clusterTable,
    },
    data () {
        return {
            labelWidth:'90px',
            searchType:'HERB',
            searchRadio:[
                {
                    value:'中药',
                    label:'HERB'
                },
                {
                    value:'症状',
                    label:'SYMP'
                },
            ],
            searchNum:10,
            distanceValue:'',
            distanceOptins:excavateData.distanceOptins,
            clusterValue:'',
            clusterOptins:excavateData.clusterOptins,
            tableList:[],
            pageInfo:{
                 pageNum: 1,
                pageTotal: 1,
                total: 1,
                pageSize: 10,
            }

        }
    },
    mounted () {
        this.getInfo();
    },
    methods: {
         ...mapMutations(['setKTable']),
        getInfo(){
            // table 同K-means一致
            getPinCi({type:this.searchType}).then((res)=>{
                let data = res.data;
                if(data&&data.code==0){
                    this.setKTable(data.data)
                    // 清除排序
                    this.$refs.cluster_table.clearSort()
                    this.$refs.cluster_table.changePage(1)
                }else{
                    this.$message.error(data.msg||'请求失败～')
                }
            })
        },
        changeRadin(val){
            this.searchType = val;
            this.getInfo();
        },
        analysis(){
            if(this.distanceValue==''||this.clusterVal==''){
                this.$message.error('请选择距离类型或聚类方法～')
                return
            }
            this.$router.push({
                path:'detailsCluster',
                query:{
                    distanceValue:this.distanceValue,
                    clusterValue:this.clusterValue,
                    searchNum:this.searchNum,
                    searchType:this.searchType,
                }
            }) 
        },
    }
}
</script>

<style>

</style>